import React from 'react';
import { Button, FormGroup, Alert } from 'react-bootstrap';
import { IResetPasswordProps } from '../../types/propTypes';
import { toast } from 'react-toastify';
import { IResetPasswordState, IResetPasswordDTO } from '../../types/stateTypes';
import LoginService from './../../services/login/login-service';
import LoginAPIService from './../../services/login/loginApi-service';
import { IAuthResponse, IResetPasswordFormField, IForgotPasswordChangeField } from '../../models/login';
import { Common } from '../../utils/constants';
import { Formik, Field } from 'formik';
import { ReactstrapInput } from '../../components/reactstrap-formik';
import { ResetPassworValidationSchema } from '../../validation/login/login-validation';
import images from '../../assets/images/index';
import { companyNameReplace } from '../../utils';
class ResetPasswordForm extends React.Component<IResetPasswordProps, IResetPasswordState> {
    state: IResetPasswordState;
    loginService: LoginService;
    loginAPIService: LoginAPIService;
    private initialState: IResetPasswordFormField = {
        NewPassWord: '',
        ConfirmPassWord: '',
        Code: '',
    };
    constructor(props: IResetPasswordProps) {
        super(props);
        this.state = {
            apiError: '',
        };
        this.loginService = new LoginService();
        this.loginAPIService = new LoginAPIService();
    }
    handleChange(evt: React.ChangeEvent<HTMLInputElement>) {
        const value = evt.target.value;
        this.setState({
            ...this.state,
            [evt.target.name]: value,
        });
    }

    handleBackButton = () => {
        this.props.onChangeStage(Common.AuthStage.FORGOT_PASSWORD);
    };

    handlePasswordChange = (value: IResetPasswordFormField) => {
        if (this.props.stage === Common.AuthStage.CHANGE_PASSWORD) {
            const email = this.props.user?.challengeParam?.userAttributes?.email;
            const resetPasswordInput: IResetPasswordDTO = {
                user: this.props.user,
                newPassWord: value.NewPassWord,
            };
            this.loginService
                .forcePasswordChange(resetPasswordInput)
                .then(async (res: IAuthResponse) => {
                    this.setState({ apiError: '' });
                    toast.success(this.props.t('login.resetPassord.success'));
                    await this.loginAPIService.emailNotification(email);
                    this.props.onAuthUser(res);
                })
                .catch(() => {
                    this.setState({ apiError: this.props.t('login.errors.generalError') });
                });
        } else {
            const forgotPassword: IForgotPasswordChangeField = {
                Email: this.props.email,
                Code: value.Code,
                PassWord: value.NewPassWord,
            };
            this.loginService
                .forgotPasswordChange(forgotPassword)
                .then(() => {
                    this.setState({ apiError: '' });
                    toast.success(this.props.t('login.resetPassord.success'));
                    this.loginAPIService.emailNotification(this.props.email);
                    this.props.onChangeStage(Common.AuthStage.SIGNIN);
                })
                .catch((error) => {
                    let errMsg = '';
                    if (error.code === Common.Auth.CODE_MISS_MATCH_EXCEPTION) {
                        errMsg = this.props.t('login.errors.verificationCodeInvalid');
                    } else {
                        errMsg = this.props.t('login.errors.generalError');
                    }
                    this.setState({ apiError: errMsg });
                });
        }
    };

    render() {
        const { t } = this.props;
        return (
            <>
                <a className="logo" href="/" title={companyNameReplace(t('login.button.instavolt'))}>
                    <img
                        className="d-block"
                        src={images.logoPNG}
                        alt={companyNameReplace(t('login.button.instavolt'))}
                    />
                </a>
                <div className="login-block">
                    {this.props.stage === Common.AuthStage.CHANGE_PASSWORD_WITH_VERIFICATION_CODE && (
                        <button
                            type="button"
                            className="btn btn-icon btn-link pr-0 btn-back"
                            title={t('login.button.back')}
                            onClick={this.handleBackButton}
                        >
                            <img className="icon" src={images.backArrowSVG} alt={t('login.button.back')} />
                        </button>
                    )}
                    <div className="title-outer pb-3">
                        <h1 className="title pb-2">{t('login.resetPassord.header')}</h1>
                        {this.props.stage === Common.AuthStage.CHANGE_PASSWORD_WITH_VERIFICATION_CODE && (
                            <p>{t('login.resetPassord.subheader')}</p>
                        )}
                    </div>
                    {this.state.apiError.length > 0 && (
                        <Alert key="errorAlert" variant="danger">
                            {this.state.apiError}
                        </Alert>
                    )}
                    <Formik
                        initialValues={this.initialState}
                        onSubmit={this.handlePasswordChange}
                        validationSchema={ResetPassworValidationSchema(t, this.props.stage)}
                    >
                        {(props) => {
                            const { handleSubmit } = props;
                            return (
                                <form onSubmit={handleSubmit} autoComplete="off">
                                    {this.props.stage === Common.AuthStage.CHANGE_PASSWORD_WITH_VERIFICATION_CODE && (
                                        <Field
                                            type="text"
                                            name="Code"
                                            id="Code"
                                            placeholder={t('login.resetPassord.placeholder.code')}
                                            component={ReactstrapInput}
                                        />
                                    )}
                                    <Field
                                        type="password"
                                        name="NewPassWord"
                                        id="NewPassWord"
                                        placeholder={t('login.resetPassord.placeholder.newPassWord')}
                                        autoComplete="new-password"
                                        component={ReactstrapInput}
                                    />
                                    <Field
                                        type="password"
                                        name="ConfirmPassWord"
                                        id="ConfirmPassWord"
                                        placeholder={t('login.resetPassord.placeholder.confirmPassWord')}
                                        autoComplete="new-password"
                                        component={ReactstrapInput}
                                    />
                                    <FormGroup>
                                        <Button
                                            type="submit"
                                            color="primary"
                                            className="btn mt-2 w-100"
                                            title={t('login.button.submitMyPassword')}
                                        >
                                            <span>{t('login.button.submitMyPassword')}</span>
                                        </Button>
                                    </FormGroup>
                                </form>
                            );
                        }}
                    </Formik>
                </div>
            </>
        );
    }
}
export default ResetPasswordForm;
